// =====================================
//
//   商品頁面 商品介紹 nav bar 事件
//   Author: Gray
//   createtime: 2016 / 05 / 04
//   Author: Gray
//   updatetime: 2016 / 05 / 04
//
// =====================================

window.InifECApp.directive('pdtNavScroll',  ['$timeout', '$state', function($timeout, $state){

    var _dir = {};

    var link = function(scope, element, attrs){

        var $window = $(window),
            $topbar = $('#nav-bar'),
            $navwrapper = $('#product-nav-wrapper'),
            $navbar = $navwrapper.find('#product-nav-bar'),
            $contents = element.find('[pdt-scroll-content]'),
            $scrollBtns = element.find('[pdt-scroll-to]'),
            topbarHeight = ($topbar && $topbar.length > 0) ? $topbar.height() : 0,
            navbarTop = ($navwrapper && $navwrapper.length > 0) ? $navwrapper.offset().top : 0,
            isInit = false,
            isFixedNavbar = false;

        var _scrollHandler = function(event) {

            if(!isInit) {
                $topbar = $('#nav-bar');
                $navbar = $('#product-nav-bar');
                $contents = element.find('[pdt-scroll-content]');
                $scrollBtns = element.find('[pdt-scroll-to]');
                topbarHeight = $topbar.length > 0 ? $topbar.height() : 0;
                navbarTop = $navwrapper.length > 0 ? $navwrapper.offset().top : 0;
                isInit = true;
            }

            if($topbar.length == 0 || $navbar.length == 0 || $contents.length == 0 || $scrollBtns.length == 0) {

                return;
            }

            var scrollTop = $window.scrollTop();

            if (scope.$$phase) {
                scope.$eval(function() {
                    if(navbarTop > 0 && topbarHeight > 0 && scrollTop - navbarTop + topbarHeight + 20 > 0) {
                        $navbar.addClass('fixed');
                        isFixedNavbar = true;
                    } else {
                        $navbar.removeClass('fixed');
                        isFixedNavbar = false;
                    }

                    $scrollBtns.removeClass('active');
                    for(var i = $contents.length - 1 ; i >= 0 ; i--){
                        var $content = $($contents[i]),
                            offset = $content.offset(),
                            height = $content.outerHeight();

                        if(topbarHeight > 0 && scrollTop - offset.top + 170 >= 0){
                            $($scrollBtns[i]).addClass('active');
                            break;
                        }
                    }

                    if((window.innerHeight + scrollTop) >= document.body.offsetHeight) {
                        $scrollBtns.removeClass('active');
                        $($scrollBtns[$scrollBtns.length - 1]).addClass('active');
                    }
                });
            } else {
                scope.$apply(function() {
                    if(navbarTop > 0 && topbarHeight > 0 && scrollTop - navbarTop + topbarHeight + 20 > 0) {
                        $navbar.addClass('fixed');
                        isFixedNavbar = true;
                    } else {
                        $navbar.removeClass('fixed');
                        isFixedNavbar = false;
                    }

                    $scrollBtns.removeClass('active');
                    for(var i = $contents.length - 1 ; i >= 0 ; i--){
                        var $content = $($contents[i]),
                            offset = $content.offset(),
                            height = $content.outerHeight();

                        if(topbarHeight > 0 && scrollTop - offset.top + 170 >= 0){
                            $($scrollBtns[i]).addClass('active');
                            break;
                        }
                    }

                    if((window.innerHeight + scrollTop) >= document.body.offsetHeight) {
                        $scrollBtns.removeClass('active');
                        $($scrollBtns[$scrollBtns.length - 1]).addClass('active');
                    }
                });
            }
        }

        var scrollHandler = function(event) {

            if(isFixedNavbar) {
                throttle(_scrollHandler(event), 10);
            } else {
                _scrollHandler(event)
            }
        }

        var reset = function() {

            $topbar = $('#nav-bar');
            $navwrapper = $('#product-nav-wrapper');
            $navbar = $navwrapper.find('#product-nav-bar');
            $contents = element.find('[pdt-scroll-content]');
            $scrollBtns = element.find('[pdt-scroll-to]');
            topbarHeight = ($topbar && $topbar.length > 0) ? $topbar.height() : 0;
            navbarTop = ($navwrapper && $navwrapper.length > 0) ? $navwrapper.offset().top : 0;
        }

        var init = function() {

            reset();

            $(window).off('scroll.pdtnav').on('scroll.pdtnav', scrollHandler);

            $(window).off('resize.pdtnav').on('resize.pdtnav', function() {
                reset();
            });

            $scrollBtns.off('click').on('click', function(event) {
                var scrollTo = $(this).attr("pdt-scroll-to");
                if(scrollTo){
                    var $content = element.find('[pdt-scroll-content='+scrollTo+']');
                    if($content.length == 0){
                        return;

                    }

                    var offset = $content.offset();
                    $('html, body').stop().animate({scrollTop: offset.top - 170}, 200);
                }
            });
        }

        scope.$on('$destroy', function() {
            $(window).off('scroll.pdtnav');
            $(window).off('resize.pdtnav');
        });

        scope.$watchCollection(attrs.pdtNavScroll, function(newValue, oldValue){
            init();
        });
        
        
    }

    _dir.restrict = 'A';
    _dir.scope = {
        pdtNavScroll: '=pdtNavScroll'
    };
    _dir.link = link;

    return _dir;
}]);